
import {
  URL_PROMO_CODES_OUTSTANDING,
} from '~/utils/constants'

const applyURLPromoCodes = async (callback)=> {
    const localStoragePromos = localStorage.getItem(URL_PROMO_CODES_OUTSTANDING)
    if(localStoragePromos) {
      const mycodes = [...localStoragePromos.split(' ')];
      for (let i = 0; i < mycodes.length; i++) {
        const promoCode = mycodes[i]
        try {
          await callback({ promoCode })
        } catch (error) {
          console.log(error)
        }
      }
    }
  }

 export  default  applyURLPromoCodes